"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.mapDispatchToInvoiceEditorProps = exports.mapStateToInvoiceEditorProps = void 0;
var ui_common_1 = require("@codametrix/ui-common");
var _a = ui_common_1.AmplifyCore.actions, removeAdditionPerformer = _a.removeAdditionPerformer, removeAdditionReferringPerformer = _a.removeAdditionReferringPerformer, chooseAdditionPerformer = _a.chooseAdditionPerformer, chooseAdditionReferringPerformer = _a.chooseAdditionReferringPerformer, changePerformDate = _a.changePerformDate, createInvoice = _a.createInvoice, addProvider = _a.addProvider, cancelChargeEdit = _a.cancelChargeEdit, chooseProvider = _a.chooseProvider, providerSearch = _a.providerSearch, removeProvider = _a.removeProvider, saveInvoice = _a.saveInvoice, departmentChange = _a.departmentChange, feeScheduleChange = _a.feeScheduleChange;
var mapStateToInvoiceEditorProps = function (state) {
    var _a, _b, _c, _d;
    return __assign(__assign({}, state.invoiceMetadata), { providerRoleTypeConfig: (_b = (_a = state === null || state === void 0 ? void 0 : state.codeBench) === null || _a === void 0 ? void 0 : _a.providerRoleTypeConfig) !== null && _b !== void 0 ? _b : [], useProviderDirectoryLocations: (_d = (_c = state === null || state === void 0 ? void 0 : state.capabilities) === null || _c === void 0 ? void 0 : _c.capabilities) === null || _d === void 0 ? void 0 : _d.useProviderDirectoryLocations });
};
exports.mapStateToInvoiceEditorProps = mapStateToInvoiceEditorProps;
var mapDispatchToInvoiceEditorProps = function (dispatch) {
    return {
        onProviderSearch: function (query) {
            dispatch(providerSearch(query));
        },
        onProviderRemove: function () {
            dispatch(removeProvider());
        },
        onProviderAdd: function (provider) {
            dispatch(chooseProvider(provider));
        },
        onInvoiceSave: function (savableInvoice) {
            dispatch(saveInvoice(savableInvoice));
        },
        onPerformerAdditionSearch: function (query) {
            dispatch(providerSearch(query));
        },
        onPerformerAdditionRemove: function () {
            dispatch(removeAdditionPerformer());
        },
        onReferringPerformerAdditionRemove: function () {
            dispatch(removeAdditionReferringPerformer());
        },
        onPerformerAdditionAdd: function (provider) {
            dispatch(chooseAdditionPerformer(provider));
        },
        onReferrerPerformerAdditionAdd: function (provider) {
            dispatch(chooseAdditionReferringPerformer(provider));
        },
        onPerformDateChange: function (newDate) {
            dispatch(changePerformDate(newDate));
        },
        onInvoiceCreate: function (createbleInvoice) { return __awaiter(void 0, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, dispatch(createInvoice(createbleInvoice))];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error from createInvoice action:', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
        onInvoiceCancel: function (e) {
            e.preventDefault();
            dispatch(cancelChargeEdit());
        },
        onDepartmentChange: function (department) {
            dispatch(departmentChange(department));
        },
        onRemoveDepartment: function () {
            dispatch(departmentChange(null));
        },
        onFeeScheduleChange: function (feeSchedule) {
            dispatch(feeScheduleChange(feeSchedule));
        }
    };
};
exports.mapDispatchToInvoiceEditorProps = mapDispatchToInvoiceEditorProps;
//# sourceMappingURL=invoice-editor-component-utilities.js.map